import React from "react";
import "./Api.css";

export default function Api() {
  return (
    <div className="page">

      {/* PREMIUM HERO */}
      <section className="api-hero">
        <div className="api-hero-inner">
          <div className="api-hero-card">

            <div className="api-pill">ENGINE PLATFORM</div>

            <h1 className="api-title">
              The ASDRY Environmental Intelligence Engine
            </h1>

            <p className="api-subtitle">
              Environmental preparation modelling built first for sporting events — and structured to power operational systems across outdoor industries. Not raw forecasts — structured impact.
            </p>

            <div className="api-actions">
              <a
                href="/contact"
                className="api-primary"
              >
                Request API Access →
              </a>

            </div>

          </div>
        </div>
      </section>

      <div className="page-container">

        {/* WHAT IT DOES */}
        <section className="content-card" style={{ marginTop: "64px" }}>
          <div className="card-body">
            <h2 className="content-subtitle">What the Engine Delivers</h2>

            <ul>
              <li>
                <strong>Multi-profile modelling</strong> — evaluates impact across competitors, volunteers, spectators, and infrastructure.
              </li>
              <li>
                <strong>AERS impact scoring</strong> — structured environmental stress levels aligned to operational risk.
              </li>
              <li>
                <strong>Organiser-ready summaries</strong> — preparation guidance designed for real-world event decisions.
              </li>
            </ul>
          </div>
        </section>

        {/* SAMPLE RESPONSE */}
        <section className="content-card" style={{ marginTop: "32px" }}>
          <div className="card-body">
            <h2 className="content-subtitle">Example Response</h2>

            <pre
              style={{
                background: "#0e2a47",
                color: "#ffffff",
                padding: "20px",
                borderRadius: "16px",
                overflowX: "auto",
                fontSize: "14px",
                lineHeight: "1.6"
              }}
            >
{`{
  "overall": {
    "aers_level": 2,
    "preparation_level": "MODERATE",
    "summary": "MODERATE risk driven mainly by rain. Increase monitoring and brief staff."
  },
  "profiles": {
    "competitor": { "aers_level": 2 },
    "volunteer": { "aers_level": 2 },
    "spectator": { "aers_level": 2 },
    "infrastructure": { "aers_level": 2 }
  }
}`}
            </pre>
          </div>
        </section>

        {/* WHO IT'S FOR */}
        <section className="content-card" style={{ marginTop: "32px" }}>
          <div className="card-body">
            <h2 className="content-subtitle">Built For</h2>

            <ul>
              <li>Multi-event sports organisers</li>
              <li>Event operations platforms</li>
              <li>Outdoor logistics & site management systems</li>
              <li>Risk & insurance modelling tools</li>
              <li>Field-based workforce platforms</li>
            </ul>
          </div>
        </section>

        {/* POSITIONING */}
        <section className="content-card" style={{ marginTop: "32px" }}>
          <div className="card-body">
            <h2 className="content-subtitle">More Than a Weather API</h2>

            <p>
              Traditional providers deliver forecasts. ASDRY delivers structured environmental interpretation.
            </p>

            <p>
              Instead of exposing raw temperature, wind, and precipitation values, the ASDRY engine models how those conditions affect operational exposure.
            </p>

            <p>
              Build on environmental intelligence — not raw weather data.
            </p>
          </div>
        </section>

        {/* FINAL CTA */}
        <section style={{ marginTop: "64px", textAlign: "center" }}>
          <a
            href="/contact"
            className="api-primary"
          >
            Start Building with ASDRY →
          </a>
        </section>

      </div>
    </div>
  );
}